import { CardHeader } from "reactstrap";
import { Link } from "react-router-dom";
import CardHeaderDropdown from "./CardHeaderDropdown";
import { CardHeaderCommonType } from "../../Type/Layout/CommonElements/CommonCardHeader";
import H3 from "../Headings/H3Element";

const CardHeaderCommon = ({title,subTitle,headClass,mainTitle,firstItem,secondItem,thirdItem,borderClass,headerClass}:CardHeaderCommonType) => {
  return (
    <CardHeader className={`${headClass} ${!borderClass === true ? "card-no-border" : ""}`}>
      <div className="header-top">
        <H3 className={headerClass}>{title}</H3>
        {subTitle && <Link to={`${process.env.PUBLIC_URL}/dashboard/ecommerce`}>{subTitle}</Link> }
        {firstItem &&
        <CardHeaderDropdown mainTitle={mainTitle} firstItem={firstItem} secondItem={secondItem} thirdItem={thirdItem} />}
      </div>
    </CardHeader>
  );
};

export default CardHeaderCommon;
